import useSWR from 'swr';

import { ProgramStats } from '@/components/app/program/GuideList/types';
import { Program } from '@/store/program/types';

import { useApi } from '../api/useApi';
import { useUserState } from '../store';

export default function useProgramStats(program: Program): {
	data: number | undefined;
	isValidating: boolean;
} {
	const user = useUserState();
	const apiRequest = useApi();

	const vals = useSWR(
		user ? `stats/programs/${program.id}` : null,
		async (endpoint: string) => {
			const response = await apiRequest<ProgramStats>({
				endpoint,
				method: 'GET',
			});

			return response?.data?.progress;
		},
		{ revalidateOnFocus: false },
	);

	return vals;
}
